<template>
  <a :href="wishlistUrl" class="wishlist-image-container" @click="triggerGtm">
    <img :src="headerIcon" :alt="headerAlt" />
    <span class="wishlist-count">{{ wishlistCount }}</span>
  </a>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'HeaderWishlist',
  props: {
    wishlistUrl: {
      type: String,
      default: '',
      required: false,
    },
    headerIcon: {
      type: String,
      default: '',
    },
    headerAlt: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      wishlistCount: 0,
    };
  },
  mounted() {
    this.updateWishlistCount();
    eventBus.on('wishlist-updated', this.updateWishlistCount);
    window.addEventListener('storage', this.onStorageChange);
  },
  beforeUnmount() {
    eventBus.off('wishlist-updated', this.updateWishlistCount);
    window.removeEventListener('storage', this.onStorageChange);
  },
  methods: {
    onStorageChange(event) {
      if (event.key === 'likedProducts' || event.key === 'likedArticles') {
        this.updateWishlistCount();
      }
    },
    updateWishlistCount() {
      const storedProducts = localStorage.getItem('likedProducts');
      const storedArticles = localStorage.getItem('likedArticles');
      const favItems = storedProducts ? JSON.parse(storedProducts) : [];
      const favArticles = storedArticles ? JSON.parse(storedArticles) : [];
      this.wishlistCount = favItems.length + favArticles.length;
    },
    triggerGtm() {
      const wishlistObj = {
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'Wishlist',
        eventAction: 'Header Wishlist',
        eventLabel: `Wishlist icon clicked`,
        event_name: 'header_wishlist_click',
      };
      window.dataLayer?.push(wishlistObj);
    },
  },
};
</script>

<style scoped>
.wishlist-image-container {
  position: relative;
  display: inline-block;
}

.wishlist-image-container .wishlist-count {
  position: absolute;
  top: -5px;
  right: -12px;
  background-color: #000;
  color: #fff;
  border-radius: 50%;
  border: 1px solid;
  text-align: center;
  font-size: 0.65rem;
  width: 1rem;
  height: 1rem;
  line-height: normal;
}

.wishlist-image-container img {
  display: block;
}

@media (max-width: 767px) {
  .wishlist-image-container {
    padding-left: 5px;
  }
}
</style>
